import { Suspense, useEffect } from 'react';
import { PricingTablePage } from '@/pages/PricingTablePage';
import { FlexCenHorVer } from '@/UI/styles';
import { PricingPageContainer } from '@/enums/pricing-page.enum';
import { useBanner, APP_BANNER_ID } from '@/hooks/useBanner';
import { AppDialogSection, AppDialog, AppDialogXBtn } from '@/UI/AppDialog/AppDialog';
import { CircularProgress } from '@/UI/CircularProgress/CircularProgress';
import { useHideTourWhile } from '@/components/ProductTours/TourContext';
import type { PricingPageViewAnalyticsContext } from '@/enums/pricing-page.enum';

interface PricingModalProps {
  open: boolean;
  analyticsContext?: PricingPageViewAnalyticsContext;
  closeModal: () => void;
  onOpen?: () => void;
}

function PricingModal({ open, analyticsContext, closeModal, onOpen }: PricingModalProps) {
  const { offset } = useBanner(APP_BANNER_ID);

  // Pauses active product tours while the pricing modal is open
  useHideTourWhile(open);

  useEffect(() => {
    if (open) {
      onOpen?.();
    }
  }, [onOpen, open]);

  return (
    <AppDialog
      open={open}
      onClose={closeModal}
      fullScreen
      sx={{
        top: offset,
        '& .MuiDialog-paperFullScreen': {
          border: 'none',
          borderRadius: 0,
        },
      }}
      slotProps={{
        backdrop: { invisible: offset > 0 ? true : false, sx: { top: offset } },
      }}
    >
      <AppDialogSection withBody sx={{ p: 0 }}>
        <Suspense
          fallback={
            <FlexCenHorVer sx={{ height: '100%', width: '100%' }}>
              <CircularProgress color="inherit" />
            </FlexCenHorVer>
          }
        >
          <PricingTablePage container={PricingPageContainer.Modal} analyticsContext={analyticsContext} />
        </Suspense>
        <AppDialogXBtn onClick={closeModal} sx={{ position: 'absolute', top: 20, right: 20 }} />
      </AppDialogSection>
    </AppDialog>
  );
}

export default PricingModal;
